import { forwardRef } from "react";
import Box from "@mui/material/Box";

/**
 * MDBox - Simplified wrapper around MUI Box
 * Maintains backward compatibility with existing page code
 */
const MDBox = forwardRef(
  ({ variant, bgColor, color, opacity, borderRadius, shadow, coloredShadow, sx, ...rest }, ref) => {
    const sxMerged = { ...sx };

    if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
      sxMerged.backgroundColor = bgColor;
    }

    if (opacity !== undefined && opacity !== 1) {
      sxMerged.opacity = opacity;
    }

    if (borderRadius && borderRadius !== 'none') {
      const radiusMap = { xs: '4px', sm: '8px', md: '12px', lg: '16px', xl: '20px', xxl: '24px', section: '16px' };
      sxMerged.borderRadius = radiusMap[borderRadius] || borderRadius;
    }

    if (shadow && shadow !== 'none') {
      const shadowMap = {
        xs: '0 1px 3px rgba(0,0,0,0.12)',
        sm: '0 2px 6px rgba(0,0,0,0.1)',
        md: '0 4px 12px rgba(0,0,0,0.12)',
        lg: '0 8px 24px rgba(0,0,0,0.15)',
        xl: '0 12px 32px rgba(0,0,0,0.18)',
      };
      sxMerged.boxShadow = shadowMap[shadow] || shadow;
    }

    if (variant === 'gradient') {
      sxMerged.background = 'var(--gradient)';
      sxMerged.color = '#fff';
    }

    return <Box ref={ref} sx={sxMerged} {...rest} />;
  }
);

MDBox.defaultProps = {
  variant: "contained",
  bgColor: "transparent",
  color: "dark",
  opacity: 1,
  borderRadius: "none",
  shadow: "none",
  coloredShadow: "none",
};

export default MDBox;
